const parsePhoneNumber = require('libphonenumber-js/min');

function parse(value, options = {}) {
  return parsePhoneNumber(value, { defaultCountry: 'SE', extract: false, ...options });
}

module.exports = {
  parse,
};
